@let mapOptions = mapOptions$ | async;
<red-map-draw-walk-order
  [mapInstance]="mapInstance"
  [walkingFarmId]="walkingFarmId"
  [(drawMode)]="isDrawMode"
  class="tw:block tw:h-full tw:w-full"
>
  @if (mapOptions) {
    <google-map height="100%" width="100%" [options]="mapOptions" (mapInitialized)="mapInitialized($event)">
      <red-user-position></red-user-position>
      <deprecated-map-marker-clusterer
        [gridSize]="100"
        [maxZoom]="15"
        imagePath="/assets/img/m"
        [zoomOnClick]="false"
        [averageCenter]="true"
        [minimumClusterSize]="30"
      >
        @for (markerData of markerData$ | async; track markerData) {
          <map-marker
            [position]="markerData.position"
            [options]="markerData.options"
            (mapClick)="openInfoWindow(markerData)"
            [clickable]="!isDrawMode"
          ></map-marker>
        }
      </deprecated-map-marker-clusterer>
      <red-walking-farm-view-map-info-window
        [walkingFarmId]="walkingFarmId"
        [property]="selectedProperty"
        (closeWindow)="closeInfoWindow()"
      ></red-walking-farm-view-map-info-window>
    </google-map>
  }
  <div class="tw:absolute tw:top-0 tw:w-full">
    <red-map-default-options>
      @if (phoneAndEmailPurchaseEnabled$ | async) {
        <ion-fab-button color="success" (click)="openPurchasePhoneAndEmailModal()" size="small">
          <ion-icon name="cart-outline"></ion-icon>
        </ion-fab-button>
      }
      <ion-fab-button (click)="centerOnBounds()" color="light" size="small">
        <ion-icon src="/assets/svg/target.svg"></ion-icon>
      </ion-fab-button>
      @if (boundariesEnabled$ | async) {
        <ion-fab-button
          (click)="toggleParcelVisibility()"
          [color]="(boundariesVisible$ | async) ? 'primary' : 'light'"
          size="small"
        >
          <ion-icon name="scan"></ion-icon>
        </ion-fab-button>
      }
    </red-map-default-options>
  </div>
</red-map-draw-walk-order>
